import Block from '../block'
import {
    backgroundColour,
    backgroundPattern,
    setTitleDecorationByClass,
    setTitleDecorationByElement,
    textAlignment
} from "../../utils/block-utils";
import classNames from "classnames";
import Action from "../../components/action";
import {listColumns} from "../list-of-items-block/design-1";
import {formatPhoneNumber} from "@autocx/forms/src/utils/phone-number";
import {useContext} from "react";
import {WebsiteContext} from "../../index";
import BusinessHoursAccordion from "./business-hours-accordion";
import LocationAddress from "./location-address";

export default function Design1(props) {
    const context = useContext(WebsiteContext);

    return (
        <Block {...props}
               className={classNames(
                   props.className,
                   !props.values.options?.inset ? backgroundPattern(props) : null,
                   !props.values.options?.inset ? backgroundColour(props.values.options?.backgroundColour) : null)
               }>
            <div className={classNames(
                "mx-auto max-w-7xl section flex flex-col items-center",
                textAlignment(props),
                props.values.options?.inset ? 'rounded-theme' : null,
                props.values.options?.inset ? backgroundPattern(props) : null,
                props.values.options?.inset ? backgroundColour(props.values?.options?.backgroundColour) : null
            )}>
                <div className={"w-full"}>
                    {props.values?.title ? (
                        <>
                            <h3 data-title=""
                                className={classNames("relative rich-text", setTitleDecorationByClass(props.values?.options?.titleDecoration))}
                                dangerouslySetInnerHTML={{__html: props.values.title}}/>
                            {props.values?.options?.titleDecoration &&
                                setTitleDecorationByElement(props.values?.options?.titleDecoration)
                            }
                        </>
                    ) : null}
                    {props.values.text ? (
                        <div data-body="" dangerouslySetInnerHTML={{__html: props.values.text}} className={"rich-text"}/>
                    ) : null}
                </div>
                <div className={classNames("relative w-full overflow-x-auto",
                    props.values.options?.listItemsMobileDisplay === "stack" ? null : "snap-mandatory snap-x sm:snap-none"
                )}>
                    <ul data-list=""
                        className={classNames(
                            "mb-4 lg:space-x-0 lg:grid gap-x-4 gap-y-6 lg:gap-x-8 lg:gap-y-12 sm:text-[length:initial] sm:leading-[initial]",
                            props.values.options?.listItemsMobileDisplay === "stack" ? "grid" : "inline-flex space-x-4",
                            props.values.options?.listItemsMobileDisplay === "stack" &&
                            props.values.options?.columnsMobile >= 3 ? "text-xs" : "",
                            listColumns(props)
                        )}>
                        {props.values.items?.map((item, i) => {
                            const location = props?.locations?.find(l => l.id === item.locationId);
                            if (!location) return null;

                            if (!location.address) location.address = {
                                addressLine1: location.addressLine1,
                                addressLine2: location.addressLine2,
                                suburb: location.suburb,
                                state: location.state,
                                postcode: location.postcode,
                                country: location.country
                            }

                            return (
                                <li key={i} data-list-item=""
                                    className={classNames(
                                        "inline-flex flex-col snap-start rounded-theme overflow-hidden lg:w-auto",
                                        props.values.options.listItemsMobileDisplay === "stack" ? "w-full" : "w-80",
                                        props.values.options?.backgroundColour === 1 ? 'section-grey' : 'section-white'
                                    )}>
                                    <div className="group flex flex-1 flex-col relative h-full rounded-theme">
                                        {item?.fields?.includes("embeddedMap") && location.embeddedMap &&
                                            <iframe data-iframe="" id={`iframe-${i}-${location.id}`}
                                                    src={location.embeddedMap}
                                                    title={"Embedded Map"}
                                                    width={"100%"}
                                                    height={350}
                                                    loading={"lazy"}
                                                    border={"none"}/>
                                        }
                                        <div
                                            className={classNames("flex flex-col flex-1 p-4", textAlignment(props))}>
                                            {(!props.values?.options?.actionStyle || props.values?.options?.actionStyle === 'noStyle') &&
                                                <Action {...item}
                                                        action={{...item.action, label: undefined}}
                                                        itemActionStyle={props.values?.options?.actionStyle}
                                                        title={null}
                                                        button={false}
                                                        defaultHref={'#'}>
                                                    <span className="absolute inset-0"/>
                                                </Action>
                                            }
                                            {item?.fields?.includes("departmentName") && location.departmentName &&
                                                <h6 data-title="">{location.departmentName}</h6>
                                            }
                                            <div className="space-y-2">
                                                {location.phoneNumber &&
                                                    <div data-phone="" className="flex items-center space-x-2">
                                                        <svg viewBox="0 0 15.07 15.07" fill="currentColor"
                                                             xmlns="http://www.w3.org/2000/svg"
                                                             className="w-5 h-4">
                                                            <path
                                                                d="M3.96875 11.0703C6.22656 13.3281 8.96875 15.0703 11.2109 15.0703C12.2188 15.0703 13.1016 14.7188 13.8125 13.9375C14.2266 13.4766 14.4844 12.9375 14.4844 12.4062C14.4844 12.0156 14.3359 11.6406 13.9688 11.375L11.5703 9.67188C11.2109 9.42188 10.8984 9.29688 10.6172 9.29688C10.2656 9.29688 9.94531 9.5 9.58594 9.85156L9.03125 10.3984C8.94531 10.4844 8.83594 10.5234 8.73438 10.5234C8.61719 10.5234 8.5 10.4766 8.42188 10.4375C7.9375 10.1797 7.10938 9.46875 6.33594 8.70312C5.57031 7.9375 4.85938 7.10938 4.60938 6.625C4.57031 6.53906 4.52344 6.42969 4.52344 6.3125C4.52344 6.21094 4.55469 6.10938 4.64062 6.02344L5.19531 5.45312C5.53906 5.09375 5.75 4.78125 5.75 4.42188C5.75 4.14062 5.625 3.83594 5.35938 3.46875L3.67969 1.10156C3.41406 0.726562 3.02344 0.5625 2.60156 0.5625C2.08594 0.5625 1.55469 0.796875 1.09375 1.24219C0.335938 1.96875 0 2.86719 0 3.85938C0 6.10156 1.71094 8.82031 3.96875 11.0703Z"/>
                                                        </svg>
                                                        <a href={`tel:${location.phoneNumber}`}>{formatPhoneNumber(location.phoneNumber)}</a>
                                                    </div>
                                                }
                                                {item?.fields?.includes("address") && (location.address) &&
                                                    <div>
                                                        <LocationAddress location={location}/>
                                                    </div>
                                                }
                                                {item?.fields?.includes("hours") && (location.sundayWorkHours || location.weekdayWorkHours || location.saturdayWorkHours || location.departmentWorkHours) &&
                                                    <div data-hours="">
                                                        <BusinessHoursAccordion location={location}/>
                                                    </div>
                                                }
                                            </div>
                                            {props.values?.options?.actionStyle !== 'noStyle' && props.values?.options?.actionStyle &&
                                                <div className={"mt-auto"}>
                                                    <Action className={"mt-3 mb-2"} {...item}
                                                            itemActionStyle={props.values?.options?.actionStyle}
                                                            title={null}/>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                <Action className={"mt-6"} {...props.values} title={null}/>
            </div>
        </Block>
    )
}
